<div class="aio-header">
  <span class="aio-header-left"></span>
  <h1>
    <a routerLink="">
      ALL in ONE
    </a>
  </h1>
  <span class="aio-header-right">
    <aio-lang-selector [selected]="lang" (selectLanguage)="selectLanguage($event)"></aio-lang-selector>
  </span>
</div>

<router-outlet></router-outlet>

<!-- Loader -->
<div *ngIf="userService.status | async; let status" class="aio-loader">
  <div class="aio-loader-content">
    <mat-spinner></mat-spinner>
    <ng-container [ngSwitch]="status">
      <div *ngSwitchCase="'connection'" class="aio-loader-content-text">{{ 'WAITING_FOR_CONNECTION' | translate }}</div>
      <div *ngSwitchCase="'userInfo'" class="aio-loader-content-text">{{ 'RETRIEVING_USER_INFO' | translate }}</div>
    </ng-container>
  </div>
</div>
  